// @flow
import * as React from 'react';
import {HashRouter as Router, Route, Routes} from 'react-router-dom';
import {ThemeProvider} from 'styled-components';
import {useLayoutState} from 'components/Layout';
import {Defaults} from 'components/Constants';
import ShowroomV2 from './showroom/Showroom';
import {ScrollToTop} from 'utils/hookUtils';

export default function PageRouter(): React.Element<any> {
  const layoutState = useLayoutState();
  const theme = React.useMemo(() => {
    return {layout: layoutState, defaults: Defaults};
  }, [layoutState]);

  return (
    <ThemeProvider theme={theme}>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="*" element={<ShowroomV2 />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}